import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../../appConstants";
import { getToken } from "../../authentication";

export const getAllRequestIssue = ({pageSize, pageNumber,Status,selectedUser,fromDate,toDate,interval,searchString,selectedDsp,issueType},role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/${role}/requestissue`, {
                pageNumber: pageNumber ? pageNumber : undefined,
                pageSize: pageSize ? pageSize : undefined,
                Status : Status ? Status : undefined,
                selectedUser : selectedUser ? selectedUser.value : undefined,
                fromDate : fromDate || undefined,
                toDate : toDate || undefined,
                interval : interval || undefined,
                searchString : searchString || undefined,
                selectedDsp : selectedDsp ? selectedDsp : undefined,
                issueType : issueType || undefined
                
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};


export const getAllIssueResponseByIssueID = ({IssueID},role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/${role}/requestissue/getIssueResponseByIssueid`, {
                issueID: IssueID ? IssueID : undefined
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};

export const getAllRequestIssueByRequestID = (req_ID,role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/${role}/requestissue/getIssueByRequestid`, {
                requestID : req_ID
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data.RequestIssue);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};



export const postRequestIssue = async (data,role) => {
    try {
        const token = getToken();
        console.log(data)
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/${role}/requestIssue`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },body:JSON.stringify(data)
            }
        );
        const res = await response.json();


        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {
        throw err;
    }
}

export const postIssueResponse = async (data,role) => {
    try {
        const token = getToken();
        console.log(data)
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/${role}/requestIssue/createResponse`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },body:JSON.stringify(data)
            }
        );
        const res = await response.json();


        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {
        throw err;
    }
}


export const changeIssueAssignee = (assigneeID,issueID,role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/${role}/requestissue/updateAssignee`, {
                assigneeID : assigneeID,
                issueID : issueID
            })
            const response = await fetch(url,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data.RequestIssue);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};

export const changeIssueType = (assigneeID,previous,current,role,type) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/${role}/requestissue/updateIssueType`, {
                issueID : assigneeID,
                previous : previous,
                current : current,
                Type:type

            })
            const response = await fetch(url,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data.RequestIssue);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};
